import { combineReducers } from "redux";
import item from "./item";
import isFetching from "./isFetching";
import isFetchingList from "./isFetchingList";
import byId from "./byId";
import deleteErrors from "./deleteErrors";

export default combineReducers({
  item,
  isFetching,
  isFetchingList,
  byId,
  deleteErrors
});



// WEBPACK FOOTER //
// ./src/reducers/user/index.js